// extracted by css-extract-rspack-plugin
export default {"cls1":"Configuration-cls1_rqm","cls2":"Configuration-cls2_JYZ Configuration-cls1_rqm"};